import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-patient-subscription-meta-view',
  templateUrl: './patient-subscription-meta-view.component.html',
  styleUrls: ['./patient-subscription-meta-view.component.scss'],
})
export class PatientSubscriptionMetaViewComponent implements OnInit {
  subscriptionMetaId: Observable<number>;
  patientGuid: Observable<string>;

  constructor(private route: ActivatedRoute) {
    this.subscriptionMetaId = this.route.paramMap.pipe(map((params) => Number.parseInt(params.get('subscriptionMetaId'))));
    this.patientGuid = this.route.paramMap.pipe(map((params) => params.get('patientGuid')));
  }

  ngOnInit() {}
}
